import { getAt } from '@finn-no/mobility-item-insertion-shared';
import { TextField, type TextFieldProps } from '@warp-ds/react';
import React from 'react';
import { Controller, type FieldError, useFormContext } from 'react-hook-form';
import type { DateWidgetModel } from '../../../types/widget.js';

type DateWidgetProps = TextFieldProps & Omit<DateWidgetModel, 'type'>;

const DateWidget = React.forwardRef<HTMLInputElement, DateWidgetProps>(({ mandatory, name, ...rest }, ref) => {
  return <TextField {...rest} type={'date' as never} optional={!mandatory} ref={ref} data-testid={name} />;
});

// TODO: Move this "Controlled" part out - it seems to be a pattern that is repeated in all widgets
export const ControlledDateWidget = ({ name, helpText, ...props }: DateWidgetProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getAt<FieldError>(errors, name);
  if (error) {
    helpText = (error.message as string) ?? 'Validation error';
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DateWidget helpText={helpText} invalid={!!error} data-attribute={name} {...props} {...field} />
      )}
      rules={{ required: props.mandatory && 'Required' }}
    />
  );
};
